import { Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import { Logo } from '../../../components/blocks';

const Root = styled.footer`
  width: 100%;
  padding: ${({ theme }) => theme.spaces.l};
  background: ${({ theme }) => theme.backgroundColors.black};
  margin-top: auto;

  ${({ theme }) =>
    theme.screen.sp({
      paddingBottom: theme.spaces.ex,
    })}
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: ${({ theme }) => theme.windowSizes.m};
  margin: ${({ theme }) => `${theme.spaces.xl} auto ${theme.spaces.xxxl}`};
  gap: ${({ theme }) => theme.spaces.l};

  ${({ theme }) =>
    theme.screen.sp({
      flexDirection: 'column',
      gap: theme.spaces.xl,
    })}
`;

const LogoWrap = styled(Link)`
  margin-top: ${({ theme }) => theme.spaces.l};
`;

const Copyright = styled.address`
  margin-bottom: ${({ theme }) => theme.spaces.l};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.fontColors.white};
  font-style: normal;
  text-align: center;
`;

export const FooterSimple: React.FC = () => {
  return (
    <Root>
      <Wrapper>
        <LogoWrap to="/">
          <Logo color="white" width="100px" />
        </LogoWrap>
      </Wrapper>
      <Copyright>&copy;2022 MEDLEY, INC.</Copyright>
    </Root>
  );
};
